import { createSelector } from '@ngrx/store';

import { MOBI_UI_HEADER_LOGO } from '@mobi/rwc-ui-components-ng-jslib';

import { OsmStep } from '../../../features/osm/shared/state/models/osm.state.model';
import * as fromOsm from '../../../features/osm/shared/state/selectors/osm.selectors';
import * as fromCore from '../../../state/selectors/core.selectors';

export const selectHeaderView = createSelector(
    fromCore.selectCurrentUser,
    fromCore.selectLoginUserData,
    fromCore.selectLoginUserProfile,
    fromCore.selectIsLoggedIn,
    fromCore.selectIsPublicZone,
    fromCore.selectLanguage,
    fromCore.selectPortalToken,
    fromOsm.selectCurrentStep,
    (
        currentUser,
        loginUserData,
        loginUserProfile,
        isLoggedIn,
        isPublicZone,
        language,
        portalToken,
        currentStep,
    ) => {
        if (!portalToken) {
            return undefined;
        }
        const portal = portalToken;
        return {
            name: currentUser
                ? currentUser?.user?.anzeigeName ||
                  concat(currentUser?.user?.vorName, currentUser?.user?.name)
                : loginUserData?.name,
            cnumber: loginUserProfile?.profileId,
            partnerNummer: currentUser?.user?.partnerNummer || loginUserProfile?.partnerId,
            renderLogin: !isLoggedIn && currentStep < OsmStep.SUCCESS,
            translationKeySuffix: !isLoggedIn ? '.public' : '',
            language,
            headerLogo:
                portal === 'protekta' ? MOBI_UI_HEADER_LOGO.PROTEKTA : MOBI_UI_HEADER_LOGO.MOBILIAR,
            portal,
        };
    },
);

function concat(...tokens: string[]) {
    return tokens.filter(token => !!token).join(' ');
}
